import { Spinner } from "@blueprintjs/core";
import { FieldSet } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";
import {
  AffixRequestApi,
  EPlatform,
  ERequestState,
  KennelOwnershipChangeRequestDto,
  NewKennelRequestDto,
  RequestDto,
} from "../../../api";
import { PageContainer } from "../../../components";
import { DrupalRequestResume } from "../../../drupal/common";
import { EDrupalRoutes } from "../../../drupal/EDrupalRoutes";
import { useTl, useApiService, useCrudApi } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalNewKennelRequestForm } from "./DrupalNewKennelRequestForm";

export interface IDrupalNewKennelRequestPageProps {}

export const DrupalNewKennelRequestPage: React.FunctionComponent<IDrupalNewKennelRequestPageProps> = (props) => {
  const { id } = useParams<{ id: string }>();

  const newKennelRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(AffixRequestApi);

  //TODO-CRR : Saving used , but no saveItem?
  const { data, loading, saving } = useCrudApi<NewKennelRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = newKennelRequestId) =>
          apiId > 0
            ? api.getNewKennelRequest(apiId)
            : new NewKennelRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: NewKennelRequestDto) =>
          api.saveKennelImportRequest(KennelOwnershipChangeRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.newKennelRequest}/${d.newKennelRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: (d) => {},
      }),
      [api, newKennelRequestId]
    ),
    [newKennelRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <FieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.NewKennelRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalNewKennelRequestForm
                  newKennelRequestId={newKennelRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </FieldSet>
    </PageContainer>
  );
};
